import { defineComponent, computed } from "vue";
import { u as useComponentPresetProp } from "../../../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useColors } from "../../../../composables/useColors-6d98be99.mjs";
const _sfc_main = defineComponent({
  name: "VaCardTitle",
  props: {
    ...useComponentPresetProp,
    textColor: { type: String }
  },
  setup(props) {
    const { getColor } = useColors();
    return {
      titleStyles: computed(() => ({
        color: props.textColor ? getColor(props.textColor) : ""
      }))
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../../VaCardTitle.css';
//# sourceMappingURL=VaCardTitle.vue_vue_type_script_lang-2d61f0a8.mjs.map
